import axios from 'axios'
import { compareValues } from '@marketplace/helpers'

const state = {
  products: [],
  orders: [],
  groups: [],
}

const getters = {
  getProducts(state) {
    return state.products
  },
  getOrders(state) {
    return state.orders
  },
  getGroups(state) {
    return state.groups
  },
}

const mutations = {
  SET_PRODUCTS(state, newValue) {
    state.products = newValue
  },
  SET_ORDERS(state, newValue) {
    state.orders = newValue
  },
  SET_GROUPS(state, newValue) {
    state.groups = newValue
  },
  UPDATE_PRODUCT(state, newValue) {
    state.products.forEach((element, index) => {
      if (element.id === newValue.id) {
        state.products[index] = newValue
      }
    })
  },
  ADD_PRODUCT(state, newValue) {
    state.products = [newValue].concat(state.products)
  },
  DELETE_PRODUCT(state, newValue) {
    state.products.forEach((element, index) => {
      if (element.id === newValue) {
        state.products.splice(index, 1)
      }
    })
  },
  ADD_ORDER(state, newValue) {
    state.orders = [newValue].concat(state.orders)
  },
  UPDATE_ORDER_STATUS(state, params) {
    state.orders.forEach((element, index) => {
      if (element.id === params.orderId) {
        state.orders[index].status = params.status
      }
    })
  },
  SORT_ORDERS(state, params) {
    state.orders.sort(compareValues(params.key, params.order))
  },
}

const actions = {
  fetchProducts({ commit, dispatch }, { companyId, params }) {
    var url = `/api/v1/company/${companyId}/store_products`
    var urlParams = ''
    if (params !== undefined && 'sortby' in params) {
      urlParams = urlParams + '?sort=' + params.sortby.split('-')[0]
      urlParams = urlParams + '&order=' + params.sortby.split('-')[1]
    }
    if (params !== undefined && 'categories' in params) {
      for (let index = 0; index < params.categories.length; index++) {
        if (urlParams === '') {
          urlParams =
            urlParams + '?category_ids[]=' + params.categories[index].id
        } else {
          urlParams =
            urlParams + '&category_ids[]=' + params.categories[index].id
        }
      }
    }
    if (params !== undefined && 'tags' in params) {
      for (let index = 0; index < params.tags.length; index++) {
        if (urlParams === '') {
          urlParams = urlParams + '?tag_ids[]=' + params.tags[index].id
        } else {
          urlParams = urlParams + '&tag_ids[]=' + params.tags[index].id
        }
      }
    }
    return axios.get(url + urlParams).then((response) => {
      commit('SET_PRODUCTS', response.data)
      return response.data
    })
  },
  fetchOrders({ commit, dispatch, store }, { companyId }) {
    return axios
      .get(`/api/v1/company/${companyId}/store_orders`)
      .then((response) => {
        commit('SET_ORDERS', response.data)
        return response.data
      })
  },
  fetchMyOrders({ commit, dispatch, store }, { companyId }) {
    return axios
      .get(`/api/v1/user/store_orders?sort=status&direction=desc`)
      .then((response) => {
        commit('SET_ORDERS', response.data)
        return response.data
      })
  },
  fetchGroupsHierarchy({ commit, dispatch }, { companyId }) {
    return axios
      .get(`/api/v1/company/${companyId}/groupsHierarchy`)
      .then((response) => {
        commit('SET_GROUPS', response.data)
        return response.data
      })
  },
  fetchCategories({ commit, dispatch }, { companyId }) {
    return axios
      .get(`/api/v1/tags/company_id/${companyId}/type/product_category`)
      .then((response) => {
        return response.data
      })
  },
  fetchTags({ commit, dispatch }, { companyId }) {
    return axios
      .get(`/api/v1/tags/company_id/${companyId}/type/product_tag`)
      .then((response) => {
        return response.data
      })
  },
  buyProduct({ commit, dispatch }, { companyId, productId, quantity }) {
    return axios
      .post(`/api/v1/company/${companyId}/store_orders`, {
        product_id: productId,
        quantity: quantity,
      })
      .then((response) => {
        commit('ADD_ORDER', response.data)
        commit('UPDATE_PRODUCT', response.data.product)
        return response.data
      })
  },
  fetchCategoriesStartingWith(
    { commit, dispatch },
    { companyId, startingWith }
  ) {
    return axios
      .get(
        `/api/v1/tags/company_id/${companyId}/type/product_category/startingWith/${startingWith}`
      )
      .then((response) => {
        return response.data
      })
  },
  fetchTagsStartingWith({ commit, dispatch }, { companyId, startingWith }) {
    return axios
      .get(
        `/api/v1/tags/company_id/${companyId}/type/product_tag/startingWith/${startingWith}`
      )
      .then((response) => {
        return response.data
      })
  },
  saveProduct({ commit, dispatch }, { companyId, product }) {
    var url = `/api/v1/company/${companyId}/store_products`
    var method = 'post'
    if (product.id) {
      url += '/' + product.id
      method = 'put'
    }
    return axios[method](url, product).then((response) => {
      if (product.id) {
        commit('UPDATE_PRODUCT', response.data)
      } else {
        commit('ADD_PRODUCT', response.data)
      }
      return response.data
    })
  },
  deleteProduct({ commit, dispatch }, { companyId, productId }) {
    return axios
      .delete(`/api/v1/company/${companyId}/store_products/${productId}`)
      .then((response) => {
        commit('DELETE_PRODUCT', productId)
        return response.data
      })
  },
  updateOrderStatus({ commit, dispatch }, { companyId, orderId, newStatus }) {
    return axios
      .put(`/api/v1/company/${companyId}/store_orders/${orderId}`, {
        status: newStatus,
      })
      .then((response) => {
        commit('UPDATE_ORDER_STATUS', { orderId: orderId, status: newStatus })
        return response.data
      })
  },
  sortOrders({ commit, dispatch }, { key, order }) {
    commit('SORT_ORDERS', { key: key, order: order })
  },
  saveStoreSettings(
    { commit, dispatch },
    { companyId, storeIsEnabled, enableGroupIds }
  ) {
    return axios
      .post(`/api/v1/company/${companyId}/store_settings`, {
        store_is_enabled: storeIsEnabled,
        enable_group_ids: enableGroupIds,
      })
      .then((response) => {
        // commit('UPDATE_ORDER_STATUS', { orderId: orderId, status: newStatus })
        return response.data
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
